export const DATE_COLUMN_WIDTH = '8.4rem';
export const ARTICLE_TYPE_COLUMN_WIDTH = '8rem';
// TODO: Set COMPANIES_COLUMN_WIDTH to 10.6rem when Ticker data is fixed
export const COMPANIES_COLUMN_WIDTH = '20rem';
export const CONTEXT_MENU_COLUMN_WIDTH = '3.2rem';
